import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18.3332C13.4311 18.3332 16.2499 15.6141 16.2499 12.124C16.2499 11.2673 16.2064 10.3488 15.7315 8.92134C15.2565 7.49392 15.1609 7.30967 14.6587 6.42813C14.4442 8.22709 13.2962 8.97684 13.0046 9.20092C13.0046 8.9678 12.3102 6.3898 11.2573 4.8473C10.2237 3.33317 8.81808 2.3398 7.99388 1.6665C7.99388 2.94557 7.63412 4.8473 7.11892 5.81625C6.60371 6.78521 6.50696 6.8205 5.86342 7.54159C5.21992 8.26267 4.92454 8.48538 4.38642 9.3603C3.84832 10.2353 3.75 11.4006 3.75 12.2574C3.75 15.7474 6.56887 18.3332 10 18.3332Z"
      fill="url(#paint0_linear_414_12967)"
      stroke="url(#paint1_linear_414_12967)"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_414_12967"
        x1={9.99996}
        y1={1.6665}
        x2={9.99996}
        y2={18.3332}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4A125" />
        <stop offset={1} stopColor="#FF4444" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_414_12967"
        x1={9.99996}
        y1={1.6665}
        x2={9.99996}
        y2={18.3332}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4A125" />
        <stop offset={1} stopColor="#FF4444" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
